// import components below
import PageHeaderUI from 'components/UI/PageHeaderUI';

// main component
const CreateTemporaryProfileHeader = () => {
  return (
    <div className='createTemporaryProfileHeader'>
      <PageHeaderUI>
        <h4>Admission Module</h4>
        <p>Dashboard / Admission / Create Temporary Profile</p>
      </PageHeaderUI>
    </div>
  );
};

export default CreateTemporaryProfileHeader;
